interface IdleGroveLogoProps {
  size?: number;
  isDark: boolean;
}

export function IdleGroveLogo({ size = 40, isDark }: IdleGroveLogoProps) {
  const cubeColor = isDark ? "#1B4B5A" : "#E07B3C";
  const cubeColorLight = isDark ? "#2A6070" : "#F4A259";
  const trunkColor = isDark ? "#2A6070" : "#D35F2D";
  const rootColor = isDark ? "#4A9BA8" : "#3D8B7A";

  return (
    <svg
      width={size}
      height={size * 0.75}
      viewBox="0 0 140 105"
      fill="none"
      style={{ transition: "all 2s ease" }}
    >
      {/* Top row - 2 cubes */}
      <rect
        x="48"
        y="0"
        width="18"
        height="18"
        rx="3"
        fill={cubeColorLight}
        style={{ transition: "fill 2s ease" }}
      />
      <rect
        x="70"
        y="0"
        width="18"
        height="18"
        rx="3"
        fill={cubeColor}
        style={{ transition: "fill 2s ease" }}
      />

      {/* Second row - 3 cubes */}
      <rect
        x="36"
        y="22"
        width="18"
        height="18"
        rx="3"
        fill={cubeColor}
        style={{ transition: "fill 2s ease" }}
      />
      <rect
        x="58"
        y="22"
        width="18"
        height="18"
        rx="3"
        fill={cubeColorLight}
        style={{ transition: "fill 2s ease" }}
      />
      <rect
        x="80"
        y="22"
        width="18"
        height="18"
        rx="3"
        fill={cubeColor}
        style={{ transition: "fill 2s ease" }}
      />

      {/* Third row - 2 cubes */}
      <rect
        x="47"
        y="44"
        width="18"
        height="18"
        rx="3"
        fill={cubeColor}
        style={{ transition: "fill 2s ease" }}
      />
      <rect
        x="69"
        y="44"
        width="18"
        height="18"
        rx="3"
        fill={cubeColorLight}
        style={{ transition: "fill 2s ease" }}
      />

      {/* Trunk */}
      <rect
        x="63"
        y="62"
        width="8"
        height="12"
        rx="2"
        fill={trunkColor}
        style={{ transition: "fill 2s ease" }}
      />

      {/* Roots - 45 degree starts, then 90 degree bends */}
      <g
        stroke={rootColor}
        strokeWidth="4"
        strokeLinecap="square"
        strokeLinejoin="miter"
        fill="none"
        style={{ transition: "stroke 2s ease" }}
      >
        {/* Center root */}
        <path d="M67 74 L67 102" />

        {/* Left side - 45 degree out, then vertical down */}
        <path d="M67 78 L52 93 L52 102" />
        {/* Far left - branches from first left root */}
        <path d="M52 93 L37 93 L37 102" />

        {/* Right side - 45 degree out, then vertical down */}
        <path d="M67 78 L82 93 L82 102" />
        {/* Far right - branches from first right root */}
        <path d="M82 93 L97 93 L97 102" />
      </g>
    </svg>
  );
}
